import React from 'react';

const UserAdvanceModal = ({
  show,
  user,
  curriculumOptions,
  selectedCurriculum,
  setSelectedCurriculum,
  onSubmit,
  onCancel
}) => {
  if (!show || !user) return null;

  const current = user.progress?.curriculum_name || '';

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h4>次に進むカリキュラムを選択してください</h4>

        {/^カリキュラム[4-9]/.test(current) && (
          <p style={{ color: 'red', fontWeight: 'bold' }}>
            ※ 現在「{current}」を受講中です
          </p>
        )}

        <select
          value={selectedCurriculum}
          onChange={(e) => setSelectedCurriculum(e.target.value)}
        >
          <option value="">-- 選択 --</option>
          {curriculumOptions.map((name) => {
            const isSame = name === current;
            const isBothApplied = /^カリキュラム[4-9]/.test(name) && /^カリキュラム[4-9]/.test(current);
            const disabled = !isSame && isBothApplied;

            return (
              <option key={name} value={name} disabled={disabled}>
                {name}{disabled ? '（進行中の他カリキュラムが未完了）' : ''}
              </option>
            );
          })}
        </select>

        <div className="modal-buttons">
          <button
            onClick={() => {
              if (!selectedCurriculum) {
                alert('カリキュラムを選択してください');
                return;
              }
              const isSame = selectedCurriculum === current;
              const isBothApplied = /^カリキュラム[4-9]/.test(selectedCurriculum) && /^カリキュラム[4-9]/.test(current);
              if (!isSame && isBothApplied) {
                alert(`カリキュラム「${current}」が進行中です。完了するまで他の応用カリキュラムには進めません。`);
                return;
              }
              onSubmit(selectedCurriculum);
            }}
          >
            進行
          </button>
          <button onClick={onCancel}>キャンセル</button>
        </div>
      </div>
    </div>
  );
};

export default UserAdvanceModal;
